"use strict";
(function(global) {
    class SecureCodeSecurityAuditAdminController {
        constructor(config) {
            this.settings = {};
            this.init(config);
        }

        init(config) {
            this.createGrid(config);
        }

        createGrid(config) {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                "columnDefinitions": [{
                    "label": "Data dodania",
                    "dataIndex": "add_date",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "isMovable": true,
                    "width": "*"
                },
                    {
                        "label": "Firma",
                        "dataIndex": "firm",
                        "dataType": "text",
                        "isEditable": false,
                        "width": "*"
                    },
                    {
                        "label": "Nazwa aplikacji",
                        "dataIndex": "application_name",
                        "dataType": "text",
                        "isEditable": false,
                        "width": "*"
                    },
                    {
                        "label": "Wersja aplikacji",
                        "dataIndex": "application_version",
                        "dataType": "text",
                        "isEditable": false,
                        "width": "*"
                    },
                    {
                        "label": "Plik PDF",
                        "dataIndex": "file_pdf",
                        "dataType": "link",
                        "isEditable": false,
                        "width": "*"
                    },
                    {
                        "label": "Plik XML",
                        "dataIndex": "file_xml",
                        "dataType": "link",
                        "isEditable": false,
                        "width": "*"
                    },
                    {
                        "label": "Akcje",
                        "dataIndex": "actions",
                        "dataType": "actions",
                        "isEditable": false,
                        "isFilterable": false,
                        "isSortable": false,
                        "width": 120
                    }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                'url': config.table_data_url,
                'baseParameters': {},
                'updateUrl': "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                "id": "gridContainerId"
            });

            new NS.Grid.Control({
                'id': "gridContainerWrapperId",
                'containerId': 'grid-container',
                'dataSource': dataSource,
                'reloadTime': null, //not implemented yet
                'autoLoad': true,
                'columnDefinitionSource': columnDefinitionSource,
                'settingsManager': settingsManager,
                'allowMultiselect': false,
                "showAllRows" : config.show_all_rows || false,
                "pageSize": (config.show_all_rows)? 99999999 : 20,
                'listeners': {
                    'onDataChanged': function() {

                    },
                    'onDataSaved': function() {

                    },
                    'onDataInvalid': function() {

                    },
                    'onDataError': function() {

                    },
                    'onSelectionChange': function(ids) {

                    }
                }
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.SecureCodeSecurityAuditAdminController = SecureCodeSecurityAuditAdminController || {};

})(window);
